import { SIZE } from '../settings/constants';
export interface ResizeData {
  window: {
    width: number;
    height: number;
  };
  stage: {
    scale: number;
  };
}

export const getSizeData = (): ResizeData => {
  const winW = window.innerWidth;
  const winH = window.innerHeight;

  const scaleW = winW / SIZE.W;
  const scaleH = winH / SIZE.H;
  const scale = Math.max(scaleW, scaleH);

  return {
    window: {
      width: winW,
      height: winH,
    },
    stage: {
      scale,
    },
  };
};
